import React, { useState } from "react";
import { toast } from 'react-toastify';

import "./uploadField.css";
import { getUploadFileUrlService } from "../../../modules/services";


const UploadField = ({ iconClass, iconSize, fieldType, isInvalid, onChange, errorMessage, inputKey, maxWidth, uploadRef=null, descriptionMessage=null }) => { 
    
    const [isPassword, setIsPassword] = useState(true);

    const handlePasswordVisible = () => { 
        setIsPassword(!isPassword);
    }

    return (
        <div style={maxWidth && {
            maxWidth: maxWidth,
            textAlign: "left"
        }}>
            <div className={
                isInvalid ?
                    'upload-input-field-control upload-input-field-invalid'
                    :
                    "upload-input-field-control"
            }>
                <i className={"bi " + iconClass + " input-icon"} style={iconSize && {fontSize: iconSize}}></i>
                <input
                    id={inputKey}
                    type="file"
                    onChange={(e) => onChange(e)}
                    ref={uploadRef ? uploadRef : null}
                    className="upload-input-field"
                />
                {
                    fieldType === "password" &&
                    <i className={
                            isPassword ?
                                "bi bi-eye-fill input-icon"
                                :
                                "bi bi-eye-slash-fill input-icon"
                        } onClick={handlePasswordVisible}></i>
                }
            </div>
            {errorMessage && <><span className="upload-input-field-invalid-text">{errorMessage}</span><br /></>}
            <span className="upload-input-field-description-text">{descriptionMessage}</span>
        </div>
    );
} 


export default UploadField;

/**
 * Uploads one or more files to S3 via backend-issued pre-signed URLs.
 *
 * @param {FileList|File[]} fileList        - Files to upload
 * @param {string}          filePath        - S3 key prefix (e.g. "profile_images")
 * @param {boolean}         isUpdating      - Whether we are replacing an existing file
 * @param {string|null}     updatingFileName - Base filename to reuse when isUpdating && updatingFileName is set
 * @returns {{ status: "OK", response: string[] } | { status: "error" }}
 */
export const UploadInputFiles = async (fileList, filePath, isUpdating = false, updatingFileName = null) => {
    let allUploadsSuccessful = true;
    let responseDocumentKeys = [];

    if (!fileList) { fileList = []; }

    for (const file of fileList) {
        try {
            let newFileName;
            const fileExtension = file.name.split('.').pop();
            const fileBaseName = file.name.replace(`.${fileExtension}`, '').replaceAll(" ", "_");

            if (isUpdating && updatingFileName) {
                newFileName = `${updatingFileName}.${fileExtension}`;
            } else {
                const timestamp = Date.now();
                newFileName = `${fileBaseName}_${timestamp}.${fileExtension}`;
            }

            const mediaKey = `${filePath}/${newFileName}`;

            const signedUrlResponse = await getUploadFileUrlService({
                "media_key": mediaKey,
                "content_type": file.type
            }, {});

            if (signedUrlResponse !== "error" && (signedUrlResponse.status_code === 200 || signedUrlResponse.status_code === 201)) {
                const uploadResponse = await fetch(signedUrlResponse.data.signed_url, {
                    method: "PUT",
                    body: file,
                });
                if (uploadResponse.ok) {
                    responseDocumentKeys.push(mediaKey);
                } else {
                    toast.error('Failed to upload file.');
                    allUploadsSuccessful = false;
                }
            } else if (signedUrlResponse !== "error") {
                allUploadsSuccessful = false;
            } else {
                window.location.href = "https://fizrobotics.com/";
            }
        } catch (error) {
            toast.error("An error occurred while uploading the file.");
            allUploadsSuccessful = false;
        }
    }

    return allUploadsSuccessful
        ? { status: "OK", response: responseDocumentKeys }
        : { status: "error" };
};
